import React, { useEffect } from "react";
import "../../App.css";
import MasterThesis from "../../images/master-thesis-image.png";
import Dimond from "../../images/process-caneachat.png";
import Sketch from "../../images/sketch.png";
import FigmaPrototype from "../../images/figmaproto.png";
import "./CaneaChat.css";
import Carusel from "../carusel/carusel";
import ContentBlock from "../contentBlock/contentBlock";
import { useMediaQuery } from "react-responsive";
import DocumentIcon from "../../images/icons/document-icon.png";
import chatbotChat from "../../images/chatbot/chatbot-chat.png";
import chatbotStart from "../../images/chatbot/chatbot-start1.png";
import chatbotSmol from "../../images/chatbot/chatbot-smol.png";
import chatbotEdit from "../../images/chatbot/chatbot-edit.png";

export default function CaneaChat() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const isMobile = useMediaQuery({ query: `(max-width: 768px)` });
  const chatbotSlides = [chatbotStart, chatbotChat, chatbotEdit, chatbotSmol];
  return (
    <div className="canea-container">
      {/* Header Section */}
      <div className="header-section">
        <div className="header-content">
          <div className="text-section">
            <h1 className="title">CANEA Chat</h1>
            <div className="extra-text">
              <p className="text">
                This project was carried out at CANEA. My colleague and I
                developed guidelines and a functional prototype for an AI
                chatbot within the CANEA ONE application. The project involved
                identifying user problems through research, designing the
                interface through sketches and prototypes, and testing the
                designs with users to finalize a functional prototype.
              </p>
              {isMobile ? (
                <p className="textSBold">
                  Made with:
                  <ul class="text">
                    <li>Figma</li>
                    <li>React.js</li>
                    <li>TypeScript</li>
                    <li>MongoDB</li>
                    <li>OpenAI API</li>
                  </ul>
                </p>
              ) : (
                <p className="text">
                  Made with:
                  <strong>
                    {" "}
                    Figma ◦ React.js ◦ TypeScript ◦ MongoDB ◦ OpenAI API
                  </strong>
                </p>
              )}
            </div>
          </div>
          <img
            src={MasterThesis}
            className="header-image"
            alt="Master Thesis"
          />
        </div>
      </div>
      <div className="process-section">
        <h1 className="title">Process</h1>

        <div className="process-content">
          {isMobile ? (
            <>
              <ContentBlock
                title="1. Understand"
                text="Questionnaires and interviews were used to gain insights from users."
              />
              <ContentBlock
                title="2. Define"
                text="The information gathered from users was analysed to find common problems and desired features for the AI Chatbot."
              />
              <ContentBlock
                title="3. Sketch"
                text="Paper sketches and wireframes were made in Figma. Two designs were developed into interactive prototypes in Figma."
              />
              <img src={Sketch} className="process-image-item" alt="Sketch" />
              <ContentBlock
                title="4. Decide"
                text="The Figma prototypes were evaluated with Heuristic Evaluation by three UX experts."
              />
              <img
                src={FigmaPrototype}
                className="process-image-item"
                alt="Figma Prototype"
              />
              <ContentBlock
                title="5. Prototype"
                text="A functional Prototype was developed using React and Open AI API."
              />
              <ContentBlock
                title="6. Validate"
                text="The functional prototype was evaluated with users by completing tasks in CANEA ONE using the prototype."
              />
            </>
          ) : (
            <>
              <div className="process-column">
                <ContentBlock
                  title="1. Understand"
                  text="Questionnaires and interviews were used to gain insights from users."
                />
                <ContentBlock
                  title="3. Sketch"
                  text="Paper sketches and wireframes were made in Figma. Two designs were developed into interactive prototypes in Figma."
                />
                <img src={Sketch} className="process-image-item" alt="Sketch" />
                <ContentBlock
                  title="5. Prototype"
                  text="A functional Prototype was developed using React and Open AI API."
                />
              </div>
              <img src={Dimond} className="process-image" alt="Process" />
              <div className="process-column">
                <ContentBlock
                  title="2. Define"
                  text="The information gathered from users was analysed to find common problems and desired features for the AI Chatbot."
                />
                <ContentBlock
                  title="4. Decide"
                  text="The Figma prototypes were evaluated with Heuristic Evaluation by three UX experts."
                />
                <img
                  src={FigmaPrototype}
                  className="process-image-item"
                  alt="Figma Prototype"
                />
                <ContentBlock
                  title="6. Validate"
                  text="The functional prototype was evaluated with users by completing tasks in CANEA ONE using the prototype."
                />
              </div>
            </>
          )}
        </div>
      </div>

      {/* Functional Prototype Section */}
      <div className="prototype-section">
        <h1 className="title">Functional Prototype</h1>
        <p className="text">
          The Functional Prototype was developed in React.js with TypeScript.
          MongoDB and Flask were used as a database for storing chat messages.
          OpenAI's API was used with the ChatGPT-3 model to give responses to
          users in the prototype.
        </p>
        <div className="carousel-container">
          <Carusel slides={chatbotSlides} />
        </div>
        <p className="report-link">
          Check out the full report here:{" "}
          {isMobile ? (
            <a
              href="http://hdl.handle.net/20.500.12380/308777"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={DocumentIcon} alt="Report" className="document-icon" />
            </a>
          ) : (
            <a
              href="http://hdl.handle.net/20.500.12380/308777"
              target="_blank"
              rel="noopener noreferrer"
            >
              http://hdl.handle.net/20.500.12380/308777
            </a>
          )}
        </p>
      </div>
    </div>
  );
}
